module.exports = __webpack_public_path__ + "img/index-section7-award5.1aa4e19f.png";